export class FetchCurrentProfileProperties {
  static readonly type = '[properties] fetch properties for current profile';
}
